import React, { useEffect } from 'react';

export default function SEO({
    title,
    description,
    keywords,
    canonicalUrl,
    ogImage,
    ogType = 'website',
    twitterCard = 'summary_large_image',
    lang = 'en',
    alternateLanguages = [],
    noindex = false,
    nofollow = false
}) {
    useEffect(() => {
        if (title) {
            document.title = title;
        }

        const head = document.head;

        const updateMetaTag = (name, content, attribute = 'name') => {
            if (!content) return;
            
            let element = document.querySelector(`meta[${attribute}="${name}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, name);
                head.appendChild(element);
            }
            element.setAttribute('content', content);
        };

        const updateLinkTag = (rel, href, hreflang = null) => {
            if (!href) return;
            
            const selector = hreflang 
                ? `link[rel="${rel}"][hreflang="${hreflang}"]`
                : `link[rel="${rel}"]`;
            
            let element = document.querySelector(selector);
            if (!element) {
                element = document.createElement('link');
                element.setAttribute('rel', rel);
                if (hreflang) {
                    element.setAttribute('hreflang', hreflang);
                }
                head.appendChild(element);
            }
            element.setAttribute('href', href);
        };

        updateMetaTag('description', description);
        updateMetaTag('keywords', keywords);
        
        if (noindex || nofollow) {
            const robotsContent = [noindex ? 'noindex' : '', nofollow ? 'nofollow' : ''].filter(Boolean).join(', ');
            updateMetaTag('robots', robotsContent);
        }

        updateMetaTag('og:title', title, 'property');
        updateMetaTag('og:description', description, 'property');
        updateMetaTag('og:type', ogType, 'property');
        updateMetaTag('og:image', ogImage, 'property');
        updateMetaTag('og:url', canonicalUrl, 'property');
        updateMetaTag('og:locale', lang === 'es' ? 'es_ES' : 'en_US', 'property');

        updateMetaTag('twitter:card', twitterCard);
        updateMetaTag('twitter:title', title);
        updateMetaTag('twitter:description', description);
        updateMetaTag('twitter:image', ogImage);

        updateLinkTag('canonical', canonicalUrl);

        alternateLanguages.forEach(({ lang: altLang, url }) => {
            updateLinkTag('alternate', url, altLang);
        });

        if (lang) {
            document.documentElement.setAttribute('lang', lang);
        }

        return () => {};
    }, [title, description, keywords, canonicalUrl, ogImage, ogType, twitterCard, lang, alternateLanguages, noindex, nofollow]);

    return null;
}
